<template>
  <div>
    <slot></slot>
  </div>
</template>

<script>

export default {
  props: {
    mensaje: { type: String, required: true },
    icon: { type: String, default: "warning" },
    iconColor: { type: String, default: "red" },
  },
  methods: {
    openDialog() {
      this.$swal({
        text: this.mensaje,
        icon: this.icon,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "gray",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        iconColor: this.iconColor,
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$emit("confirmado");
        }else{
          this.$emit("sinConfirmar")
        }
      });
    },
  },
};
</script>
